import { baseApi } from "api/BaseApi";

import {
  PublicProtectionProfile,
  PublicProtectionProfileCounts,
} from "./protectionProfiles.types";

const PP_BASE_URL = "/protection-profile";

export const publicProtectionProfilesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listPublicProtectionProfiles: build.query<PublicProtectionProfile[], void>({
      query: () => `${PP_BASE_URL}/public_pps_all/`,
    }),
    loadPpCounts: build.query<PublicProtectionProfileCounts, void>({
      query: () => `${PP_BASE_URL}/get_pp_counts/`,
    }),
  }),

  overrideExisting: false,
});

export const { useListPublicProtectionProfilesQuery, useLoadPpCountsQuery } =
  publicProtectionProfilesApi;
